import { lazy, useEffect } from "react";
import MainLayout from "layout/MainLayout";
import Loadable from "components/Loadable";
import { AES, enc } from "crypto-js";
import * as url from "../store/constant/Endpoints";
import {

} from "helper/permissionsCheck";
import AllTenant from "pages/tenant-management/AllTenant";
import AddTenants from "pages/tenant-management/AddTenants";
import ViewTenantReport from "pages/tenant-management/ViewTenantReport";
const DashboardDefault = Loadable(lazy(() => import("pages/dashboard")));
const AlllAssigPermissions = Loadable(
  lazy(() => import("pages/assignpermission/allassingpermissions"))
);
const CreateAssignPermission = Loadable(
  lazy(() => import("pages/assignpermission/createassignpermission"))
);
const AllAssPremiDetails = Loadable(
  lazy(() => import("pages/assignpermission/allassigndetails"))
);
const AllRoles = Loadable(lazy(() => import("pages/roles/allroles")));
const RegisterUser = Loadable(
  lazy(() => import("pages/user-management/registerUser"))
);

const PermissionsAssign = Loadable(
  lazy(() => import("pages/permissions/assign"))
);
const AllUsers = Loadable(lazy(() => import("pages/user-management/allusers")));
// ==============================|| MAIN ROUTES ||============================== //
// let permissionUser = localStorage.getItem('LoginData');
// let permissions = JSON.parse(permissionUser)?.permissions;

let permissionUser = localStorage.getItem("data");

let decryptedData = null;
if (permissionUser) {
  try {
    // Code that may throw an exception
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(
      enc.Utf8
    );
    // ...
  } catch (error) {
    localStorage.clear();
    window.location.reload();
  }
}

const permissionsAssrray =
  decryptedData && JSON.parse(decryptedData)?.user_type;

// useEffect(() => {
//   window.location.href = "/payments/all-payments";
// }, [permissionsAssrray]);

const MainRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: <MainLayout />,
      children:
        permissionsAssrray == "bank_user"
          ? []
          : [
            {
              path: "/",
              element: <AllTenant />,
            },
            {
              path: "dashboard",
              element: <AllTenant />,
            },
            {
              path: "*",
              element: <AllTenant />,
            },
          ],
    },
    true
      ? {
        path: "roles",
        element: <MainLayout />,
        children: [
          true
            ? {
              path: "all-roles",
              element: <AllRoles />,
            }
            : null,
        ].filter(Boolean),
      }
      : null,

    true
      ? {
        path: "permissions",
        element: <MainLayout />,
        children: [
          true
            ? {
              path: "all-permissions",
              element: <PermissionsAssign />,
            }
            : null,
        ].filter(Boolean),
      }
      : null,

    true
      ? {
        path: "users",
        element: <MainLayout />,
        children: [
          true
            ? {
              path: "all-users",
              element: <AllUsers />,
            }
            : null,
        ].filter(Boolean),
      }
      : null,

    true
      ? {
        path: "users",
        element: <MainLayout />,
        children: [
          true
            ? {
              path: "register-users",
              element: <RegisterUser />,
            }
            : null,
        ].filter(Boolean),
      }
      : null,
true
      ? {
        path: "tenants",
        element: <MainLayout />,
        children: [
          true
            ? {
              path: "all-tenants",
              element: <AllTenant />,
            }
            : null,
        ].filter(Boolean),
      }
      : null,
true
      ? {
        path: "tenants",
        element: <MainLayout />,
        children: [
          true
            ? {
              path: "add-tenant",
              element: <AddTenants />,
            }
            : null,
        ].filter(Boolean),
      }
      : null,
      true
      ? {
        path: "tenants",
        element: <MainLayout />,
        children: [
          true
            ? {
              path: "view-tenant-report/:id",
              element: <ViewTenantReport />,
            }
            : null,
        ].filter(Boolean),
      }
      : null,
  ].filter(Boolean),
};

export default MainRoutes;
